var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-tab2-inner",class:{'my-tab2-inner-checked':_vm.showType},on:{"click":_vm.clickTab}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }